import { Layers, Compass, Sparkles, Settings, ArrowLeft, Plus, Mic, Send, ArrowRight, Play, Pause, Activity, FileText, Trash, Edit2, CheckCircle2, XCircle, Clock, Copy, Check } from 'lucide-react';

export const Icons = {
  Scenarios: Layers,
  Marketplace: Compass,
  Assistant: Sparkles,
  Settings: Settings,
  Layers: Layers,
  Sparkles: Sparkles,
  ArrowLeft, Plus, Mic, Send, ArrowRight, Play, Pause, Activity, FileText, Trash, Edit2, CheckCircle2, XCircle, Clock, Copy, Check
};
